<script>
    import { mobile_menu_toggle } from "./store/mobile_menu_toggle.js";
    import { token } from "./store/token.js";
    import { user } from "./store/user.js";
    import { workspace_list } from "./store/workspace_list.js";
    import { client_login } from "./store/client_login.js";

    import General from "./account/General.svelte";

    import Workspaces from "./account/Workspaces.svelte";
    import WorkspaceOverview from "./account/WorkspaceOverview.svelte";
    import WorkspaceOverviewChangePlan from "./account/WorkspaceOverviewChangePlan.svelte";
    import WorkspaceSSOConfig from "./account/WorkspaceSSOConfig.svelte";
    import WorkspaceMemberList from "./account/WorkspaceMemberList.svelte";
    import WorkspaceCreate from "./account/WorkspaceCreate.svelte";
    import WorkspaceCreateSubscribe from "./account/WorkspaceCreateSubscribe.svelte";

    import Security from "./account/Security.svelte";
    import SecurityDeviceDetail from "./account/SecurityDeviceDetail.svelte";
    import ConnectedAccounts from "./account/ConnectedAccounts.svelte";
    import Billing from "./account/Billing.svelte";
    import BillingPaymentMethods from "./account/BillingPaymentMethods.svelte";
    import BillingPlanOverview from "./account/BillingPlanOverview.svelte";

    import { section } from "./store/section.js";

    export let check_error;

    const set_section = (selected_section) => {
        section.set(selected_section);
    };

    if (!$section) {
        set_section("account/general");
    }

    console.log("token=", $token);

    const logout = () => {
        var result = confirm("Do you really want to log out?");

        if (!result) {
            return;
        }

        token.set("");
        workspace_list.set([]);
        user.set({});
    };

    /*!(function (t, e) {

        var o, n, p, r;
        e.__SV ||
            ((window.posthog = e),
            (e._i = []),
            (e.init = function (i, s, a) {
                function g(t, e) {
                    var o = e.split(".");
                    2 == o.length && ((t = t[o[0]]), (e = o[1])),
                        (t[e] = function () {
                            t.push(
                                [e].concat(
                                    Array.prototype.slice.call(arguments, 0),
                                ),
                            );
                        });
                }
                ((p = t.createElement("script")).type = "text/javascript"),
                    (p.crossOrigin = "anonymous"),
                    (p.async = !0),
                    (p.src =
                        s.api_host.replace(
                            ".i.posthog.com",
                            "-assets.i.posthog.com",
                        ) + "/static/array.js"),
                    (r =
                        t.getElementsByTagName(
                            "script",
                        )[0]).parentNode.insertBefore(p, r);
                var u = e;
                for (
                    void 0 !== a ? (u = e[a] = []) : (a = "posthog"),
                        u.people = u.people || [],
                        u.toString = function (t) {
                            var e = "posthog";
                            return (
                                "posthog" !== a && (e += "." + a),
                                t || (e += " (stub)"),
                                e
                            );
                        },
                        u.people.toString = function () {
                            return u.toString(1) + ".people (stub)";
                        },
                        o =
                            "init capture register register_once register_for_session unregister unregister_for_session getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey getNextSurveyStep identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty createPersonProfile opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing debug".split(
                                " ",
                            ),
                        n = 0;
                    n < o.length;
                    n++
                )
                    g(u, o[n]);
                e._i.push([i, s, a]);
            }),
            (e.__SV = 1));
    })(document, window.posthog || []);
    posthog.init("abcdef", {
        api_host:
            "https://b3996943-4e96-4587-820f-4a54069b4750-00-5f8mflwmc8h4.picard.replit.dev",
    });

    posthog.identify("ondra");

    posthog.capture("user_signed_up", {
        login_type: "email",
        is_free_trial: true,
    });*/

    console.log("toggle state", $mobile_menu_toggle);
    const toggleMobileMenu = () => {
        console.log("pre", $mobile_menu_toggle, "next", !$mobile_menu_toggle);
        mobile_menu_toggle.set($mobile_menu_toggle == "0" ? "1" : "0");
        console.log("post", $mobile_menu_toggle);
    };
</script>

<div class="settings-page" id="wrapper">
    <div class="wrapper-holder">
        <main class="main-content-holder">
            <div
                class="main-content-container {$mobile_menu_toggle == '1'
                    ? 'nav-active'
                    : ''}"
            >
                <div class="nav-container">
                    <a
                        class="close-nav"
                        href="#a"
                        on:click={() => {
                            toggleMobileMenu();
                        }}><i class="icon icon-close" /></a
                    >
                    <div class="nav-card">
                        <div class="nav-card-header">
                            <div class="logo-nav">
                                <a href="#a"
                                    ><img
                                        src="../account/images/logo-nav.svg"
                                        alt="Vollume"
                                        width="64"
                                        height="18"
                                    /></a
                                >
                            </div>
                        </div>
                        <div class="nav-card-body">
                            <nav>
                                <ul class="nav-main nav-settings">
                                    <li
                                        on:click={() => {
                                            toggleMobileMenu();
                                            set_section("account/general");
                                        }}
                                        class={$section == "account/general"
                                            ? "active"
                                            : ""}
                                    >
                                        <a class="nav-main-link" href="#">
                                            <div class="user-block">
                                                <div
                                                    style="height:36px;width:36px;border: 1px rgba(255, 255, 255, .06) solid;border-radius: 20px;"
                                                >
                                                    {#if $user.avatar_url}
                                                        <div
                                                            class="avatar"
                                                            style="margin-right:0 !important;font-weight:600; color: {$user.name_text_color}; font-size:0.8rem;margin-left:-0.5px;margin-top:-0.5px"
                                                        >
                                                            <img
                                                                src={$user.avatar_url}
                                                                width="42"
                                                                height="42"
                                                                alt="avatar"
                                                            />
                                                        </div>
                                                    {:else}
                                                        <div
                                                            class="avatar"
                                                            style="margin-right:0 !important;font-weight:600; background-color: {$user.name_background_color}; color: {$user.name_text_color}; font-size:0.8rem"
                                                        >
                                                            {$user.name_abbreviation}
                                                        </div>
                                                    {/if}
                                                </div>
                                                <div
                                                    class="user-text"
                                                    style="margin-left:12px"
                                                >
                                                    <p>
                                                        <strong
                                                            class="name"
                                                            style="text-overflow: ellipsis;"
                                                            >{$user.name ||
                                                                $user.email}</strong
                                                        >
                                                    </p>
                                                    <div class="d-lg-none">
                                                        <p>Go to settings</p>
                                                    </div>
                                                    <div
                                                        class="d-none d-lg-block"
                                                        style="color:#ADAFB2; margin-top:-2px"
                                                    >
                                                        <p>Edit profile</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <hr
                                            class="divider"
                                            style="opacity:0.7"
                                        />
                                    </li>
                                    <!--
                                    <li
                                        on:click={() => {
                                            set_section("account/general");
                                        }}
                                        class={$section == "account/general"
                                            ? "active"
                                            : ""}
                                    >
                                        <a class="nav-main-link" href="#">
                                            <div class="df-row df-aic gx-2">
                                                <div class="col-auto">
                                                    <span class="ico-holder"
                                                        ><i
                                                            class="icon icon-user"
                                                        /></span
                                                    >
                                                </div>
                                                <div class="col">
                                                    <span class="item-text"
                                                        >General</span
                                                    >
                                                </div>
                                            </div></a
                                        >
                                    </li>
                                    -->
                                    <li
                                        on:click={() => {
                                            toggleMobileMenu();
                                            set_section("account/workspaces");
                                        }}
                                        class={$section.indexOf(
                                            "account/workspaces",
                                        ) != -1
                                            ? "active"
                                            : ""}
                                    >
                                        <a class="nav-main-link" href="#">
                                            <div class="df-row df-aic gx-2">
                                                <div class="col-auto">
                                                    <span class="ico-holder">
                                                        <img
                                                            src="../account/images/2025-icon-workspaces.png"
                                                            width="42"
                                                            height="42"
                                                            alt="avatar"
                                                        />
                                                        <!--<i
                                                            class="icon icon-users"
                                                        />
                                                        -->
                                                    </span>
                                                </div>
                                                <div class="col">
                                                    <span class="item-text"
                                                        >Workspaces</span
                                                    >
                                                </div>
                                            </div></a
                                        >
                                    </li>
                                    <li
                                        on:click={() => {
                                            toggleMobileMenu();
                                            set_section("account/security");
                                        }}
                                        class={$section.indexOf(
                                            "account/security",
                                        ) != -1
                                            ? "active"
                                            : ""}
                                    >
                                        <a class="nav-main-link" href="#a">
                                            <div class="df-row df-aic gx-2">
                                                <div class="col-auto">
                                                    <span class="ico-holder">
                                                        <img
                                                            src="../account/images/2025-icon-security.png"
                                                            width="42"
                                                            height="42"
                                                            alt="avatar"
                                                        />
                                                        <!--<i
                                                            class="icon icon-devices"
                                                        />
                                                        --->
                                                    </span>
                                                </div>
                                                <div class="col">
                                                    <span class="item-text"
                                                        >Security</span
                                                    >
                                                </div>
                                            </div></a
                                        >
                                    </li>
                                    <!--
                                        <li>
                                        <a class="nav-main-link" href="#a">
                                            <div class="df-row df-aic gx-2">
                                                <div class="col-auto">
                                                    <span class="ico-holder"
                                                        ><i
                                                            class="icon icon-download"
                                                        /></span
                                                    >
                                                </div>
                                                <div class="col">
                                                    <span class="item-text"
                                                        >Download Control</span
                                                    >
                                                </div>
                                            </div></a
                                        >
                                    </li>
                                -->
                                </ul>
                            </nav>
                        </div>
                        <div class="nav-card-footer">
                            <!--
                                <a
                                class="btn btn-dark"
                                href="#"
                                on:click={() => {
                                    window.location.href =
                                        "control://closewebview";
                                }}>Close window</a
                            >
                            -->
                            {#if $client_login != true}
                                <a
                                    class="btn btn-dark"
                                    href="#"
                                    on:click={() => {
                                        logout();
                                    }}>Sign out</a
                                >
                            {/if}
                        </div>
                    </div>
                </div>
                <div class="settings-container">
                    <div class="card-nav-settings">
                        <div class="nav-card-header">
                            <div class="header-row">
                                <div class="d-xl-none">
                                    <a class="nav-opener" href="#"
                                        ><i class="icon icon-navigation" /></a
                                    >
                                </div>
                                <strong class="settings-title"
                                    >Vollume settings</strong
                                >
                            </div>
                        </div>
                        <!--
                        <div class="nav-card-body">
                            <nav>
                                <ul
                                    class="nav-first-level nav-settings nav-text-hide-mobile"
                                >
                                    <li
                                        on:click={() => {
                                            set_section("account/general");
                                        }}
                                        class={$section == "account/general"
                                            ? "active"
                                            : ""}
                                    >
                                        <a
                                            class="opener-second-level"
                                            href="#a"
                                        >
                                            <div class="df-row df-aic gx-2">
                                                <div class="col-auto">
                                                    <span class="ico-holder"
                                                        ><i
                                                            class="icon icon-user"
                                                        /></span
                                                    >
                                                </div>
                                                <div class="col">
                                                    <div class="opener-text">
                                                        <strong
                                                            class="nav-title"
                                                            >General</strong
                                                        >
                                                        <div class="nav-text">
                                                            <p>
                                                                Add/change
                                                                avatar and setup
                                                                your general
                                                                information
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div></a
                                        >
                                    </li>
                                    <li
                                        on:click={() => {
                                            set_section("account/workspaces");
                                        }}
                                        class={$section == "account/workspaces"
                                            ? "active"
                                            : ""}
                                    >
                                        <a
                                            class="opener-second-level"
                                            href="#a"
                                        >
                                            <div class="df-row df-aic gx-2">
                                                <div class="col-auto">
                                                    <span class="ico-holder"
                                                        ><i
                                                            class="icon icon-users"
                                                        /></span
                                                    >
                                                </div>
                                                <div class="col">
                                                    <div class="opener-text">
                                                        <strong
                                                            class="nav-title"
                                                            >Workspaces</strong
                                                        >
                                                        <div class="nav-text">
                                                            <p>
                                                                Manage your
                                                                existing
                                                                workspaces
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div></a
                                        >
                                    </li>
                                    <li
                                        on:click={() => {
                                            set_section("account/security");
                                        }}
                                        class={$section == "account/security"
                                            ? "active"
                                            : ""}
                                    >
                                        <a
                                            class="opener-second-level"
                                            href="#a"
                                        >
                                            <div class="df-row df-aic gx-2">
                                                <div class="col-auto">
                                                    <span class="ico-holder"
                                                        ><i
                                                            class="icon icon-devices"
                                                        /></span
                                                    >
                                                </div>
                                                <div class="col">
                                                    <div class="opener-text">
                                                        <strong
                                                            class="nav-title"
                                                            >Security</strong
                                                        >
                                                        <div class="nav-text">
                                                            <p>
                                                                View and manage
                                                                connected
                                                                devices
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div></a
                                        >
                                    </li>
                                    <li
                                        on:click={() => {
                                            set_section(
                                                "account/connected_accounts"
                                            );
                                        }}
                                        class={$section ==
                                        "account/connected_accounts"
                                            ? "active"
                                            : ""}
                                    >
                                        <a class="opener-second-level" href="#">
                                            <div class="df-row df-aic gx-2">
                                                <div class="col-auto">
                                                    <span class="ico-holder"
                                                        ><i
                                                            class="icon icon-connected"
                                                        /></span
                                                    >
                                                </div>
                                                <div class="col">
                                                    <div class="opener-text">
                                                        <strong
                                                            class="nav-title"
                                                            >Connected accounts</strong
                                                        >
                                                        <div class="nav-text">
                                                            <p>
                                                                Manage connected
                                                                account and
                                                                integrations
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div></a
                                        >
                                    </li>-->
                        <!--<li
                                        on:click={() => {
                                            set_section("account/billing");
                                        }}
                                        class={$section == "account/billing" ||
                                        $section ==
                                            "account/billing_payment_methods"
                                            ? "active"
                                            : ""}
                                    >
                                        <a class="opener-second-level" href="#">
                                            <div class="df-row df-aic gx-2">
                                                <div class="col-auto">
                                                    <span class="ico-holder"
                                                        ><i
                                                            class="icon icon-billing"
                                                        /></span
                                                    >
                                                </div>
                                                <div class="col">
                                                    <div class="opener-text">
                                                        <strong
                                                            class="nav-title"
                                                            >Billing</strong
                                                        >
                                                        <div class="nav-text">
                                                            <p>
                                                                Overview your
                                                                latest
                                                                transactions
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div></a
                                        >
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div class="nav-card-footer">
                            <a class="btn btn-primary" href="#">Upgrade Plan</a>
                            <p>
                                Get more out of Vollume — <a href="#"
                                    >Compare Plans</a
                                >
                            </p>
                        </div>
                        -->
                    </div>

                    <!-- component include -->
                    {#if $section == "account/general"}
                        <General />
                    {:else if $section == "account/workspaces"}
                        <Workspaces check_error={check_error} />
                    {:else if $section == "account/workspaces/create"}
                        <WorkspaceCreate />
                    {:else if $section == "account/workspaces/create_subscribe"}
                        <WorkspaceCreateSubscribe />
                    {:else if $section == "account/workspaces/overview"}
                        <WorkspaceOverview check_error={check_error} />
                    {:else if $section == "account/workspaces/overview/change_plan"}
                        <WorkspaceOverviewChangePlan check_error={check_error} />
                    {:else if $section == "account/workspaces/overview/sso_config"}
                        <WorkspaceSSOConfig />
                    {:else if $section == "account/workspaces/overview/member_list"}
                        <WorkspaceMemberList />
                    {:else if $section == "account/security"}
                        <Security />
                    {:else if $section == "account/security/device_detail"}
                        <SecurityDeviceDetail />
                    {:else if $section == "account/connected_accounts"}
                        <ConnectedAccounts />
                    {:else if $section == "account/workspaces/overview/billing"}
                        <Billing />
                    {:else if $section == "account/workspaces/overview/billing/payment_methods"}
                        <BillingPaymentMethods />
                    {:else if $section == "account/workspaces/overview/billing/plan"}
                        <BillingPlanOverview />
                    {:else}
                        Loading...
                    {/if}
                </div>
            </div>
        </main>
    </div>
</div>

<style>
    .avatar {
        clip-path: circle(17px at center);
    }
</style>
